module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mmsbnp3-ce0ccae74c1ddfc1852497aa352f0b2f.jpg";